//------------------------------------------------------ funciones
import { subscribeTable, updateRow } from "./supabaseRealtime";
import { supabase } from "../supabase/SupabaseClient";
import { redimensionarImagen } from "../functions/imageFunctions";

const TABLA = "users";

export const subscribeUsers = (callback) => subscribeTable(TABLA, callback);

// Redimensiona a <=512x512, sube a Storage (bucket "avatars", nombrado
// "<auth.uid()>.jpg" -- así la policy de Storage puede limitar que cada
// usuario solo pisa su propio archivo) y actualiza el campo foto_url
// en la fila de `users` (identificada por su id propio, no por el uid
// de auth -- son ids distintos, ver nota en AuthContext).
export const actualizarFotoUsuario = async ({ userRowId, authUid, archivo }) => {
  const blob = await redimensionarImagen(archivo, 512);
  const path = `${authUid}.jpg`;

  const { error: uploadError } = await supabase.storage
    .from("avatars")
    .upload(path, blob, { contentType: "image/jpeg", upsert: true });
  if (uploadError) throw uploadError;

  const { data: pub } = supabase.storage.from("avatars").getPublicUrl(path);
  // cache-bust: si el usuario cambia la foto, el browser no debe seguir
  // mostrando la vieja por el nombre de archivo idéntico.
  const fotoUrl = `${pub.publicUrl}?t=${Date.now()}`;

  await updateRow(TABLA, userRowId, { foto_url: fotoUrl });

  return fotoUrl;
};
